<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

<!-- Content Header -->
<section class="content-header">
  <div class="container-fluid">

    <!-- Slim Mobile Toolbar -->
    <div class="toolbar-row">
      <a routerLink="/" class="toolbar-btn">
        <i class="fas fa-home"></i>
      </a>

      <h5 class="toolbar-title mb-0">
        Vehicles at the Port/CFS
      </h5>

      <button class="toolbar-btn" disabled>
        <i class="fas fa-car"></i>
      </button>
    </div>

    <!-- Search -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text bg-white border-success">
              <i class="fas fa-search"></i>
            </span>
          </div>

          <input
            type="text"
            class="form-control border-success"
            placeholder="Search"
            (input)="onSearchTextChange($event)"
          />
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Content -->
<section class="content">
  <div class="container-fluid">

    <!-- Alerts -->
    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <!-- Vehicle Cards -->
    <div
      class="card shadow-sm rounded-lg mb-3"
      *ngFor="let vehicle of vehicles | searchVehicle: searchText | paginate: { itemsPerPage: 10, currentPage: page, totalItems: count }"
    >
    <a routerLink="/mobile/vehicle-details/{{vehicle.vehicle_id}}">
      <div class="card-body p-3">

        <div class="row align-items-center">

          <!-- Vehicle Image -->
          <div class="col-4 col-md-2 text-center">
            <img
              [src]="vehicle.main_photo || 'assets/no-photo.png'"
              class="img-fluid rounded"
              style="max-height:100px; object-fit:cover;"
            />
          </div>

          <!-- Vehicle Details -->
          <div class="col-8 col-md-10">

            <h4 class="text-danger mb-2 font-weight-bold text-uppercase">
              {{ vehicle.make }} {{ vehicle.model }}
            </h4>

            <h5 class="text-success mb-2">
              Chassis No.: {{ vehicle.chassis_no }}
            </h5>

            <p class="mb-1">
              <strong>Colour:</strong> {{ vehicle.colour }}
              &nbsp;&nbsp;
              <strong>Year:</strong> {{ vehicle.year }}
            </p>

            <small class="text-dark">
              Location: On Port
            </small>

          </div>

        </div>

      </div>
    </a>
    </div>

    <!-- Pagination -->
    <pagination-controls
      (pageChange)="pageChangeEvent($event)">
    </pagination-controls>

  </div>
</section>
